<template>
    <div class="get-started-progress-container">
        <div
            v-for="progress in stepProgress"
            :key="progress"
            :style="progressStyle(progress)"
            class="step-progress"
        ></div>
    </div>
</template>
<script>
    export default {
        name: 'Progress',
        props: {
            status: {
                type: Number,
                validator: (v) => v === null || (v >= 0 && v <= 5)
            },
            disabled: {
                type: Boolean
            }
        },
        data: () => ({
            numberOfSteps: 5
        }),
        computed: {
            stepProgress: (self) => [...Array(self.numberOfSteps).keys()],
            progressStyle: (self) => (progress) => {
                return (self.status && progress < self.status) ||
                    (self.status === progress && self.disabled)
                    ? { background: '#cdeb09' }
                    : {}
            }
        }
    }
</script>
<style lang="scss" scoped>
    .get-started-progress-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 4px;

        .step-progress {
            max-width: 133px;
            min-width: 50px;
            width: 100%;
            height: 16px;
            background: #262626;
        }
        .step-progress:first-child {
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
        }

        .step-progress:last-child {
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
        }
    }
</style>
